angular.module("coursemap").component("resources", {
  templateUrl: "templates/dash/resources.html",
  bindings: {}
})
